import * as React from 'react';
import { Theme } from '@mui/styles';
import { useState, useEffect } from "react";
import {Button} from '@mui/material';
import {Dialog, DialogTitle, DialogContent, DialogActions, Typography} from '@mui/material';
import * as request from "superagent";
import DashboardCardConfig from "~dashboard/components/dashboard-card-config-fc";
import LoadingView from "~common/components/loading-view";
import { makeStyles, createStyles } from "@mui/styles";

interface Props extends React.HTMLProps<HTMLDivElement> {
   classes: any;
   handleFunctionDialogClose: ()=>void
   handleCardDialogComplete: ()=>void
   handleDashboardConfigChange: ()=>void
   _dashboardConfig: any;
   _results: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalContent: {
        minHeight: 300, 
        minWidth: 300
    }
  })
);

export const AddDashboardCard: React.FC<Props> = ({
    handleFunctionDialogClose,
    handleCardDialogComplete,
    handleDashboardConfigChange,
    _dashboardConfig,
    _results
}) => {

    const classes = useStyles();    
    
    const [ready, setReady] = useState(undefined)
    const [userLimitReached, setUserLimitReached] = useState(undefined)
    const [limit, setLimit] = useState(undefined)

    useEffect(()=>{
        request.get("/api/dashboards/validations/user-dashboard-card-limit").then((response: request.Response)=>{
            if (response.body?.maxDashboardCards) {
                setUserLimitReached(true)
                setLimit(response.body?.limit)
            }
            setReady(true)
        })
    }, [])

    const configView = (
        <DashboardCardConfig
            onConfigChange={handleDashboardConfigChange}
            config={_dashboardConfig}
            results={_results}
        />
    );

    return (
        <Dialog
            open={true}
            onClose={handleFunctionDialogClose}
        >
        
        <DialogTitle>Add to Dashboard</DialogTitle>

        {!ready && <DialogContent className={classes.modalContent}><LoadingView classes={{}} /></DialogContent>}
        
        {ready && userLimitReached && 
        <DialogContent className={classes.modalContent}>
            <Typography>
                You have reached the maximum dashboard card limit of {limit}. You must delete a dashboard card before you can create a new one.
            </Typography>
        </DialogContent>}

        {ready && !userLimitReached && 
        <DialogContent className={classes.modalContent}>
            <div>{configView}</div>
        </DialogContent>}
        
        {ready && !userLimitReached && <DialogActions>
            <Button
                variant="contained"
                onClick={handleFunctionDialogClose}
                color="inherit"
            >
                Cancel
            </Button>
            <Button
                autoFocus={true}
                onClick={handleCardDialogComplete}
                variant="contained"
                color="primary"
            >
                Save
            </Button>
        </DialogActions>}

         {ready && userLimitReached && <DialogActions>
            <Button
                variant="contained"
                onClick={handleFunctionDialogClose}
                color="primary"
            >
                Cancel
            </Button>
        </DialogActions>}

        </Dialog>
    );
}

export default AddDashboardCard;